import { ProgressPortraitMetrics } from '../model/ProgressPortrait';
import { CellData, NO_DATA_CELL, Segment } from '../components/ProgressBar';
import { isEmpty } from 'lodash';
import { format } from 'date-fns';

export type Level = 'low' | 'medium' | 'high' | 'NA';

export const COLOR_BY_LEVEL: Required<{ [key in Level]: string }> = {
  low: '#E7D4FA',
  medium: '#8FF1F1',
  high: '#FFD8A9',
  NA: '#EBE9F1',
};

export type MetricDataExtractor<MetricData> = (
  progressPortraitMetrics: ProgressPortraitMetrics,
) => MetricData[];
export type ToCellFunction<MetricData> = (toCellData: MetricData) => CellData;
export type MetricProgressBar = {
  progressPortraitMetrics: ProgressPortraitMetrics[];
};

export function groupBy<T, Key>(
  collections: T[],
  groupFunction: (element: T) => Key,
): Map<Key, T[]> {
  return collections.reduce((map, element) => {
    const key = groupFunction(element);
    const groupedElements = map.get(key);
    if (!groupedElements) {
      const group = [element];
      map.set(key, group);
    } else {
      groupedElements.push(element);
    }
    return map;
  }, new Map());
}

export function toProgressSegments<Metric>(
  progressPortraitMetrics: ProgressPortraitMetrics[],
  metricExtractor: MetricDataExtractor<Metric>,
  toCellData: ToCellFunction<Metric>,
  cellComparator?: (point1: Metric, point2: Metric) => number,
): Segment[] {
  return progressPortraitMetrics.map((interval) => {
    const period = interval.vinelandAssessmentDate;
    const metricData = metricExtractor(interval);
    const sortedData = cellComparator
      ? [...metricData].sort(cellComparator)
      : metricData;
    const cells = isEmpty(metricData)
      ? [NO_DATA_CELL]
      : sortedData.map((metric) => toCellData(metric));
    return {
      period: period,
      cells: cells,
    };
  });
}

export const formatDateMMddYYYY = (date?: Date) =>
  date ? format(date, 'MM/dd/yyyy') : '';
